export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/fire-5b31a904daacd83c1ab82c24debd8730.svg";